import React, { useState, useRef, useEffect } from 'react';
import SuperAdminHeader from './SuperAdminHeader';
import SuperAdminSidebar from './SuperAdminSidebar';
import './SuperAdminLayout.css';

const SuperAdminLayout = ({ children, title }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const headerRef = useRef(null);
  const layoutRef = useRef(null);

  const handleMenuToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleSidebarClose = () => {
    setIsSidebarOpen(false);
  };

  useEffect(() => {
    const measureHeaderHeight = () => {
      if (headerRef.current && layoutRef.current) {
        const headerHeight = headerRef.current.offsetHeight;
        layoutRef.current.style.setProperty('--header-height', `${headerHeight}px`);
      }
    };

    requestAnimationFrame(() => {
      measureHeaderHeight();
    });

    const handleResize = () => {
      requestAnimationFrame(() => {
        measureHeaderHeight();
      });
    };

    const resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        measureHeaderHeight();
      });
    });

    if (headerRef.current) {
      resizeObserver.observe(headerRef.current);
    }

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div ref={layoutRef} className="super-admin-layout">
      <SuperAdminHeader headerRef={headerRef} onMenuToggle={handleMenuToggle} isSidebarOpen={isSidebarOpen} />
      <div className="super-admin-layout-body">
        <SuperAdminSidebar isOpen={isSidebarOpen} onClose={handleSidebarClose} />
        <div className="super-admin-layout-content">
          <main className="super-admin-layout-main">
            {title && (
              <div className="super-admin-layout-page-header">
                <h1 className="super-admin-layout-title">{title}</h1>
              </div>
            )}
            <div className="super-admin-layout-page-content">
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminLayout;

